module.exports = "/_next/static/images/407d2d4cbfd179b2a20b99041f6425f2-word-cup-lg-3x.png";